import React from 'react';
import '../css/AboutUs.css';

import johnDoeImg from '../Images/img1.png';
import janeSmithImg from '../Images/img2.jpg';
import bobJohnsonImg from '../Images/img3.jpg';

const contributors = [
  {
    name: 'John Doe',
    image: johnDoeImg,
    text: 'Frontend developer with experience in ReactJS and VueJS',
  },
  {
    name: 'Jane Smith',
    image: janeSmithImg,
    text: 'Backend developer with experience in NodeJS and Python',
  },
  {
    name: 'Bob Johnson',
    image: bobJohnsonImg,
    text: 'Full-stack developer with experience in Java and PHP',
  },
];

const ContributorCard = ({ name, image, text }) => {
  return (
    <div className="contributor-card">
      <img src={image} alt={name} />
      <h3>{name}</h3>
      <p>{text}</p>
    </div>
  );
};

export default function About() {
  return (

      <div className="about-us">
      <h1>About Us</h1>
      {/* <div className="contributors">
        {contributors.map((contributor) => (
          <ContributorCard key={contributor.name} {...contributor} />
        ))}
      </div> */}
      <div className='para'>
      <p>We are a group of three college students who are passionate about
         software development and collaboration. Our miniproject for college
          is to create a collaborative code editor that makes it easy for 
        developers to work together remotely. As a team, we bring
         a diverse set of skills and experiences to the table. We believe that 
         collaboration is key to building great software, and our goal is to create a platform that makes it easy for developers to work together,
          share ideas, and learn from each other.</p>
      </div>
      <h3>Thank you for visiting our website, and we hope you find our platform useful!</h3>
    </div>
  )
}
